var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _vm._v(" "),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipo === "T",
                    expression: "tipo === 'T'"
                  }
                ],
                attrs: { for: "proveedores" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.params.proveedores,
                      expression: "params.proveedores"
                    }
                  ],
                  attrs: { type: "checkbox", id: "proveedores" },
                  domProps: {
                    checked: Array.isArray(_vm.params.proveedores)
                      ? _vm._i(_vm.params.proveedores, null) > -1
                      : _vm.params.proveedores
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.params.proveedores,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.params,
                                "proveedores",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.params,
                                "proveedores",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.params, "proveedores", $$c)
                        }
                      },
                      function($event) {
                        return _vm.$refs.listaItems.loadRows()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Mostrar items de proveedores")])
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoProducto === "T",
                    expression: "tipoProducto === 'T'"
                  }
                ],
                attrs: { for: "tItems" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.params.tipoItem,
                      expression: "params.tipoItem"
                    }
                  ],
                  attrs: { type: "radio", id: "tItems", value: "T" },
                  domProps: { checked: _vm._q(_vm.params.tipoItem, "T") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.params, "tipoItem", "T")
                      },
                      function($event) {
                        return _vm.$refs.listaItems.loadRows()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Todos los ítems")])
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoProducto === "T",
                    expression: "tipoProducto === 'T'"
                  }
                ],
                attrs: { for: "productos" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.params.tipoItem,
                      expression: "params.tipoItem"
                    }
                  ],
                  attrs: { type: "radio", id: "productos", value: "P" },
                  domProps: { checked: _vm._q(_vm.params.tipoItem, "P") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.params, "tipoItem", "P")
                      },
                      function($event) {
                        return _vm.$refs.listaItems.loadRows()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Productos")])
              ]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tipoProducto === "T",
                    expression: "tipoProducto === 'T'"
                  }
                ],
                attrs: { for: "servicios" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.params.tipoItem,
                      expression: "params.tipoItem"
                    }
                  ],
                  attrs: { type: "radio", id: "servicios", value: "S" },
                  domProps: { checked: _vm._q(_vm.params.tipoItem, "S") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.params, "tipoItem", "S")
                      },
                      function($event) {
                        return _vm.$refs.listaItems.loadRows()
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Servicios")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaItems",
        attrs: {
          params: _vm.params,
          filterStatus: _vm.filterStatus,
          createButton: _vm.createButton,
          editButton: false,
          deleteButton: false,
          path: _vm.url + "/items/search",
          columns: [
            {
              display: "Código",
              value: "codigo"
            },
            {
              display: "Tipo",
              value: "descripcion_tipo_item"
            },
            {
              display: "Tipo de item",
              value: "descripcion_tipo"
            },
            {
              display: "Categoría",
              value: "descripcion_categoria"
            },
            {
              display: "Nombre",
              value: "nombre"
            },
            {
              display: "Descripción",
              value: "descripcion"
            },
            {
              display: "Marca",
              value: "descripcion_marca"
            },
            {
              display: "Precio de venta",
              value: "precio_venta"
            },
            {
              display: "Subsidio",
              value: "valor_subsidio"
            },
            {
              display: "IVA",
              value: "iva"
            },
            {
              display: "ICE",
              value: "ice"
            },
            {
              display: "IRBPNR",
              value: "descripcion_irbpnr"
            }
          ]
        },
        on: { crear: _vm.crear, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "item"
          }
        },
        [
          _c("item", {
            attrs: {
              tipoProducto: _vm.tipoProducto,
              tipo: _vm.tipo,
              searchButton: _vm.searchButton
            },
            on: { saved: _vm.createdItem, created: _vm.createdItem }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Ítems")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39f61597", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39f61597","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/items/ListaItem.vue
// module id = 366
// module chunks = 0